import classNames from "classnames";

import AscHeading from "../../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import styles from "./AscTracksCompletedCard.module.scss";
import AscImage from "../../AscImage/AscImage";
import AscButton from "../../AscButton/AscButton";

export interface AscTracksCompletedCardProps {
  header: string;
  title: string;
  description: string;
  className?: string;
  onButtonClick?: () => void;
  src?: string;
}

export default function AscTracksCompletedCard({
  header,
  title,
  description,
  onButtonClick,
  className,
  src,
}: AscTracksCompletedCardProps) {
  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.top}>
        <div>
          <AscParagraph className={styles.header}>{header}</AscParagraph>
          <AscHeading className={styles.title}>{title}</AscHeading>
        </div>
        <AscImage className={styles.badge} src={src || ""} />
      </div>
      <AscParagraph className={styles.description}>{description}</AscParagraph>
      <AscButton onClick={onButtonClick}>Go to track</AscButton>
    </div>
  );
}
